///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    templateUrl: './AppViews/Timesheet/addTimesheet.html'
})

export class AddTimesheetComponent implements OnInit {
    showLoader = false;
    invalidRecord: boolean = false;
    constants: Constants;
    timesheetDetails: any = {};
    projectList: any = [];
    taskList: any = [];
    timesheetItems: any = [];
    userDetail: any;
    objTotalTimeSpent: any = 0;
    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
    addTimesheet: any = {};
    addTimesheetFormActive: any = true;
    newItem = { 'ProjectId': "", 'TaskTypeId': "", 'TimeSpent': 0, 'Comments': "", 'TaskList': [] };
    getProjectUrl: any;
    teamItems:any[]=[];
    isDisable: boolean = false;
    recordItem: any = [JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem)), JSON.parse(JSON.stringify(this.newItem))];
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe, private route: ActivatedRoute, private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        // this.route
        //     .params
        //     .subscribe(
        //     data => {
        //         this.timesheetDetails.Timesheet_Id = data["timesheetId"];
        //     }
        //     );
        // if (this.timesheetDetails.Timesheet_Id != 0) {
                    //this.GetTimesheet();
        //}


    }

    ngOnInit() {
        //if (this.userDetail.RoleId == 3) {
            //this.getProjectUrl = "Project/GetAssignedProject"
        //} else {
           //this.getProjectUrl = "Project/GetProject"
        //}
        this.GetProjectList();
        //this.GetTaskList();

    }

    ngAfterViewInit() {
        var today = moment().format('YYYY-MM-DD');
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY',
            maxDate: today
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });



    }

    ngAfterViewChecked() {
        if (this.projectList.length > 0) {
            $('.dataSearch').selectpicker({
                style: 'btn-info',
                size: 4
            });

            $('.selectPicker').selectpicker({ style: 'btn-info' });
        }


    }

    public clearFilter() {
        //$(".dataSearch").val('').selectpicker('refresh');
        this.filter = { 'FromDate': moment().format('DD/MM/YYYY') };
    }

    GetProjectList() {
        this.showLoader=true;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //  if(this.userDetail.RoleId==3){
                 TeamId=0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
        }
        this._httpService.ajaxPost("Project/GetAssignedProject",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 0, "UserId": UserId }).subscribe(
            data => {
                this.projectList = data["ProjectList"];                
            },
            err => { console.log("GetProjectList Failed");this.showLoader=false;},
            () => {
                this.GetTimesheet();
                this.showLoader=false;
            }
            );
    }

    GetTaskList(val, index) {       
        if (val == "") {
            this.recordItem[index].TaskList = [];
            this.recordItem[index].TaskTypeId = '';
        }
        else {
            //get task type list from taskGroupList from projecttaskGroup by project type of project id
            //projectId->projectType->projectTaskGroupList->projectTaskTypeList
            //this.filter.UserId = this.siteUserItems.filter((item) => item.TeamID == val)[0].Site_UserId;
            this.showLoader=true;
            this._httpService.ajaxPost("TaskType/GetTaskTypeByProjectId",
                { "ProjectId": val }).subscribe(
                data => {
                    this.recordItem[index].TaskList = data["TaskTypeList"];
                },
                err => {
                    this.showLoader=false;
                },
                () =>{
                    this.showLoader=false;
                }
                );
        }
    }

    GetTotalTimeSpent() {
        this.objTotalTimeSpent = 0
        this.recordItem.forEach(element => {
            if (element.TimeSpent == "") {
                element.TimeSpent = 0;
            }
            // else
            // {
            this.objTotalTimeSpent += parseInt(element.TimeSpent);
            //}
        });
    }

    GetTimesheet() {
        this.showLoader=true;
        this.isDisable = false;
        this._httpService.ajaxPost("Timesheet/GetTimesheet",
            {
                "TimesheetId": 0,
                "UserId": this.userDetail.SiteUserId,
                "ProjectId": 0,
                "FromDate": this.filter.FromDate,
                "ToDate": null,
                "TaskTypeId": 0,
                "TaskGroupId": 0,
                "TeamId": this.userDetail.TeamID,
                "LoggedInUser": this.userDetail.SiteUserId
            }).subscribe(
            data => {
                this.timesheetItems = data["TimesheetList"];
            },
            err => { console.log("GetTimesheetList Failed"); this.showLoader=true;},
            () => {
                this.recordItem = [];
                for (var i = 0; i < this.timesheetItems.length; i++) {
                    var iItem = { 'ProjectId': "", 'TaskTypeId': "", 'TimeSpent': 0, 'Comments': "", 'TaskList': [] };                  
                    iItem.ProjectId = this.timesheetItems[i].ProjectId;
                    this.GetTaskList(iItem.ProjectId, i);
                    iItem.TaskTypeId = this.timesheetItems[i].TaskTypeId;
                    iItem.TimeSpent = this.timesheetItems[i].TimeSpent;
                    iItem.Comments = this.timesheetItems[i].Comments;
                    if(this.isDisable == false && this.timesheetItems[i].Process_Id > 0)
                    {
                        this.isDisable = true;
                    }
                    this.recordItem.push(iItem);
                }
                var count = 0;
                if (this.recordItem.length <= 3) {
                    count = (3 - this.recordItem.length);
                }
                for (var i = 0; i < count; i++) {
                    this.recordItem.push(JSON.parse(JSON.stringify(this.newItem)));
                }
                console.log("RRPP"+ JSON.stringify( this.recordItem));
                this.GetTotalTimeSpent();
                this.showLoader=false;
            }
            );
    }

    AddRecord() {
        //add new record to timesheet grid
        this.recordItem.push(JSON.parse(JSON.stringify(this.newItem)));
    }

    DeleteRecord(index) {
        //delete record to timesheet grid
        this.recordItem.splice(index, 1);
        this.GetTotalTimeSpent();
    }

    ValidateTimesheet(controlName, index) {
        if (controlName == "" && index == 0) {
            this.invalidRecord = false;
            for (var i = 0; i < this.recordItem.length; i++) {
                var ProjectId = $('#ProjectId' + i).val();
                var TaskTypeId = $('#TaskTypeId' + i).val();
                var Timespent = $('#TimeSpent' + i).val();
                var Comments = $('#Comments' + i).val();

                var isNumber = /^\d+$/.test(Timespent);
                if (ProjectId == "" && TaskTypeId == "" && (Timespent == "" || Timespent == "0" || isNumber == false) && Comments == "") {
                    $('#ProjectId' + i).siblings(".btn-info").removeAttr("style");
                    $('#TaskTypeId' + i).siblings(".btn-info").removeAttr("style");
                    $('#TimeSpent' + i).parent().removeClass("has-error");
                    $('#Comments' + i).parent().removeClass("has-error");
                }
                else {
                    if (ProjectId == "") {
                        this.invalidRecord = true;
                        $('#ProjectId' + i).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                    }

                    if (TaskTypeId == "") {
                        this.invalidRecord = true;
                        $('#TaskTypeId' + i).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
                    }

                    if (Timespent == "" || Timespent == "0" || isNumber == false) {
                        this.invalidRecord = true;
                        $('#TimeSpent' + i).parent().addClass("has-error");
                    }
                    else {
                        if (isNaN(Timespent)) {
                            this.invalidRecord = true;
                            $('#TimeSpent' + i).parent().addClass("has-error");
                        }
                    }

                    if (Comments == "") {
                        this.invalidRecord = true;
                        $('#Comments' + i).parent().addClass("has-error");
                    }
                }
            }
            if (!this.invalidRecord) {
                this.AddTimesheet();
            }
        }
        else {
            var Control = $('#' + controlName + index).val();
            var isNo = /^\d+$/.test(Control);
            if (Control == "" || Control == "0") {
                this.invalidRecord = true;
                $('#' + controlName + index).parent().addClass("has-error");
                $('#' + controlName + index).siblings(".btn-info").attr("style", "border-color:#a94442 !important");
            }
            else {
                if (controlName == "TimeSpent" && isNo == false) {
                    $('#' + controlName + index).parent().addClass("has-error");
                }
                else {
                    $('#' + controlName + index).parent().removeClass("has-error");
                    $('#' + controlName + index).siblings(".btn-info").removeAttr("style");
                }

            }
        }

    }

    AddTimesheet() {
        debugger
        console.log(this.recordItem);

        let objItem: any = [];
        this.recordItem.forEach(element => {
            if (element.ProjectId == "" || element.TaskTypeId == "" || element.TimeSpent == "" || element.TimeSpent == "0" || element.Comments == "")
            { }
            else {
                let objRecord: any = {};
                objRecord.UserId = this.userDetail.SiteUserId;
                objRecord.TimeSheet_Date = this.filter.FromDate;
                objRecord.ProjectId = element.ProjectId;
                objRecord.TaskTypeId = element.TaskTypeId;
                objRecord.TimeSpent = element.TimeSpent;
                objRecord.Comments = element.Comments;
                objRecord.Created_By = this.userDetail.SiteUserId;
                objRecord.Modified_By = this.userDetail.SiteUserId;
                objItem.push(objRecord);
            }
        });
        console.log(JSON.stringify(objItem));
        if (objItem.length > 0) {
            let objTimesheet: any = { "TimesheetList": objItem };
            this._httpService.ajaxPost('Timesheet/AddTimesheet', objTimesheet).subscribe(
                data => {

                    var msg = data["Status"].Message.split('|');
                    if (msg.length > 1) {
                        //if (message[0] == "warning") {
                        //    //vm.isWarning = true;
                        //}
                        msg[0] = msg[0].toLowerCase();
                        //this._toasterService.pop(msg[0], msg[1]);
                        this._sharedService.ShowMessage(data["Status"].Message);

                        //redirect to timesheet page
                        this._route.navigateByUrl("/timesheet");
                    }
                    else {
                        //this._toasterService.pop('success', msg);
                        this._sharedService.ShowMessage(data["Status"].Message);
                    }
                }
            );
        }
        else {
            this._sharedService.ShowMessage("error|Enter atleast one record");
        }
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Timesheet/addTimesheet.component.ts
 **/